<template>
  <!-- 新增全屏遮罩层（仅移动端显示） -->
  <div
    v-if="!isMobile && isIOS && showMask"
    class="fullscreen-mask"
    @click="handleMaskClick"
  >
    <div class="mask-content">
      <h2>欢迎访问</h2>
      <p>点击屏幕进入</p>
    </div>
  </div>
  <!-- 顶部导航 -->
  <div class="container" :class="{ scrolled: isScrolled }">
    <img :src="logo" alt="Logo" />
    <ul class="banner_ul">
      <li
        class="banner_li"
        v-for="(item, index) in list"
        :key="index"
        @click="LiClick(item)"
        @mouseenter="item.name === '展览展示' ? (showItem = true) : null"
        @mouseleave="showItem = false"
      >
        {{ item.name }}
        <div v-if="item.name === '展览展示' && showItem" class="menuItem">
          <ul>
            <li
              v-for="(sub, i) in menuItemList"
              :key="i"
              @click.stop="menuItemClick(sub)"
            >
              {{ sub.name }}
            </li>
          </ul>
        </div>
      </li>
    </ul>
    <!-- 返回顶部按钮 -->
    <button v-if="showBackToTop" class="back-to-top" @click="scrollToTop">
      返回顶部
    </button>
  </div>

  <!-- 主内容区域 -->
  <router-view />

  <!-- 固定右下角 iframe 弹窗 -->
  <!-- <iframe
    class="floating-iframe"
    :style="{ bottom: `${iframeOffset}px` }"
    src="https://rtc.yuanshijiuxi.com/dashboard.html"
    frameborder="0"
    allow="geolocation; microphone; camera; fullscreen"
  ></iframe> -->
  <!--<iframe
    id="rtc-iframe"
    class="floating-iframe"
    :style="{ bottom: `${iframeOffset}px` }"
    src="https://rtc.yuanshijiuxi.com/dashboard.html"
    frameborder="0"
    allow="geolocation; microphone; camera; fullscreen"
  ></iframe>-->
  <!-- 页脚 -->
  <div class="footer">
    <div class="first_footer_box">
      <div class="footer_left_box_img">
        <img :src="footerLogo" alt="Footer Logo" />
      </div>
      <p>联系地址：北京市丰台区日月天地A座1602</p>
      <p>联系电话：13001981825</p>
      <p>邮箱：437521951@qq.com</p>
    </div>
    <div class="the_footer_box">
      <ul>
        <li>
          <img :src="ewm1" alt="联系我们二维码" />
          <p>联系我们</p>
        </li>
        <li>
          <img :src="ewm2" alt="微信公众号二维码" />
          <p>微信公众号</p>
        </li>
        <li>
          <img :src="ewm3" alt="小红书二维码" />
          <p>小红书</p>
        </li>
      </ul>
    </div>
  </div>
  <div class="footerICP">
    <a
      href="https://beian.miit.gov.cn/"
      target="_blank"
      rel="noopener noreferrer"
    >
      ICP主体备案号 京ICP备2023035518号
    </a>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from "vue";
import { useRouter } from "vue-router";
import { useThrottleFn } from "@vueuse/core"; // 需要先安装 @vueuse/core

// 资源引入
import logo from "@/assets/menjiMiniLogo.webp";
import footerLogo from "@/assets/footerLogo.webp";
import ewm1 from "@/assets/ewm1.webp";
import ewm2 from "@/assets/ewm2.webp";
import ewm3 from "@/assets/ewm3.webp";
// 新增代码
const isMobile = ref(true);
const showMask = ref(true);
// 新增：判断是否为 iOS 系统
const isIOS = ref(false);

const checkIOS = () => {
  // const ua = navigator.userAgent.toLowerCase();
  // isIOS.value = /iphone|ipad|ipod/.test(ua);
  // 同时直接触发视频播放（双保险）
  setTimeout(() => {
    document.querySelectorAll("video").forEach((video) => {
      try {
        video.play().catch((e) => console.error("视频播放失败:", e));
      } catch (e) {
        console.error("视频播放异常:", e);
      }
    });
  }, 50);
};

// 修改原有 checkMobile 方法
const checkMobile = () => {
  checkIOS(); // 先检查是否是 iOS
  // isMobile.value = window.innerWidth <= 768;
};

// 点击遮罩处理
const handleMaskClick = () => {
  showMask.value = false;
  // // 触发全局事件
  // // 增强的交互事件触发
  // const event = new Event("user-interact", {
  //   bubbles: true,
  //   cancelable: true,
  // });
  // window.dispatchEvent(event);
  // // 2. 直接模拟 iframe 点击（核心解决方案）
  // const simulateIframeClick = () => {
  //   const iframe = document.getElementById("rtc-iframe");
  //   if (!iframe) return;

  //   // 方法1：直接调用 iframe 的 click() 方法
  //   try {
  //     iframe.click();
  //   } catch (e) {
  //     console.log("直接点击方法失败", e);
  //   }

  //   // 方法2：创建并触发点击事件（更可靠）
  //   const rect = iframe.getBoundingClientRect();
  //   const clickEvent = new MouseEvent("click", {
  //     view: window,
  //     bubbles: true,
  //     cancelable: true,
  //     clientX: rect.left + rect.width / 2,
  //     clientY: rect.top + rect.height / 2,
  //   });

  //   iframe.dispatchEvent(clickEvent);

  //   // 方法3：使用 postMessage 与 iframe 内部通信
  //   try {
  //     iframe.contentWindow.postMessage(
  //       {
  //         type: "simulate-click",
  //         data: { x: rect.width / 2, y: rect.height / 2 },
  //       },
  //       "https://rtc.yuanshijiuxi.com"
  //     );
  //   } catch (e) {
  //     console.log("postMessage通信失败", e);
  //   }
  // };

  // // 延迟执行确保 iframe 已加载
  // setTimeout(simulateIframeClick, 500);
  // // 获取 iframe 并触发交互
  // const iframe = document.querySelector(".floating-iframe");
  // if (iframe) {
  //   try {
  //     // 尝试调用 iframe 内部方法
  //     iframe.contentWindow.postMessage(
  //       "user-interact",
  //       "https://rtc.yuanshijiuxi.com"
  //     );
  //   } catch (error) {
  //     console.error("无法与 iframe 通信:", error);
  //   }
  // }
};
const router = useRouter();
// 新增 iframe 相关状态
const iframeOffset = ref(180); // 初始位置与 CSS 中的 bottom: 120px 一致
const lastScrollY = ref(0);
// 响应式状态
const isScrolled = ref(false);
const showBackToTop = ref(false);
const showItem = ref(false);

// 使用节流函数（50ms 间隔）
const throttledHandleScroll = useThrottleFn(handleScroll, 50);
// 菜单列表
const list = ref([
  { name: "首页", path: "/" },
  { name: "源AI", path: "/YuanAI" },
  { name: "克隆数字人", path: "/CopyAI" },
  { name: "元宇宙", path: "/Metaverse" },
  { name: "数字孪生", path: "/Digital" },
  { name: "虚拟制片", path: "/bition" },
  { name: "智旅新篇", path: "/Travel" },
  { name: "展览展示" },
  { name: "联系我们" },
]);

const menuItemList = ref([
  { name: "线下展馆", path: "/exhibition" },
  { name: "VR", path: "/VR" },
  { name: "VP", path: "/VP" },
]);

// 监听滚动
function handleScroll() {
  isScrolled.value = window.scrollY >= 200;
  showBackToTop.value = window.scrollY > 300;
  const currentScrollY = window.scrollY;
  const direction = currentScrollY > lastScrollY.value ? "up" : "down";
  lastScrollY.value = currentScrollY;

  // 调整 iframe 位置（每次调整 5px，范围 20px-120px）
  iframeOffset.value = Math.max(
    50,
    Math.min(220, iframeOffset.value + (direction === "down" ? -15 : 15))
  );
}

function scrollToTop() {
  window.scrollTo({ top: 0, behavior: "smooth" });
}

onMounted(() => {
  // document.addEventListener("WeixinJSBridgeReady", () => {
  //   const iframe = document.getElementById("rtc-iframe");
  //   iframe.contentWindow.postMessage("force-play", "*");
  // });
  checkMobile();
  window.addEventListener("resize", checkMobile);
  window.addEventListener("scroll", throttledHandleScroll);
});

onUnmounted(() => {
  window.removeEventListener("resize", checkMobile);
  window.removeEventListener("scroll", throttledHandleScroll);
});

// 一级菜单点击
function LiClick(item) {
  scrollToTop();
  if (item.path) {
    isScrolled.value = false;
    router.push(item.path);
  } else if (item.name === "展览展示") {
    showItem.value = !showItem.value;
  } else if (item.name === "联系我们") {
    window.scrollTo({
      top: document.documentElement.scrollHeight,
      behavior: "smooth",
    });
  }
}

// 二级菜单点击
function menuItemClick(sub) {
  scrollToTop();
  isScrolled.value = false;
  router.push(sub.path);
  showItem.value = false;
}
</script>
<style lang="scss">
.fullscreen-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.9);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  text-align: center;

  .mask-content {
    h2 {
      font-size: 24px;
      margin-bottom: 20px;
    }

    p {
      font-size: 16px;
    }
  }
}

@media (min-width: 769px) {
  .fullscreen-mask {
    display: none !important;
  }
}

.container {
  position: fixed;
  z-index: 1;
  width: 100%;
  height: 54px;
  background-color: #181818;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: background-color 0.3s, color 0.3s;

  &.scrolled {
    background-color: #f1f2f2;
    color: #000 !important;

    .banner_li {
      .menuItem li {
        background-color: #f1f2f2 !important;
      }
    }
  }

  img {
    margin-left: 50px;
  }

  .banner_ul {
    display: flex;
    align-items: center;
    font-size: 12px;
  }
}

.back-to-top {
  position: fixed;
  bottom: 80px;
  right: 40px;
  /* rest unchanged */
}

.floating-iframe {
  /* 添加过渡效果 */
  transition: bottom 0.5s ease;
  /* 其他原有样式保持不变 */
  position: fixed;
  right: 20px;
  width: 400px;
  height: 700px;
  z-index: 1000;
}

.footerICP {
  font-size: 1rem;
  width: 100%;
  text-align: center;
  padding-bottom: 10px;
}

.container {
  position: relative;
}

.back-to-top {
  width: 5%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  bottom: 80px;
  right: 40px;
  padding: 10px 18px;
  font-size: 12px;
  background-color: #000;
  color: #fff;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: opacity 0.3s;
}

html,
body {
  margin: 0;
  padding: 0;

  &::-webkit-scrollbar {
    display: none;
    width: 0px !important;
    /* Chrome Safari */
  }
}

ul,
li {
  list-style: none;
  padding: 0;
  margin: 0;
}

.container {
  background-color: black;
  color: white;
  transition: background-color 0.3s, color 0.3s;

  &.scrolled {
    background-color: #f1f2f2;
    color: #000 !important;

    .banner_li {
      line-height: 54px;
      height: 54px;
      position: relative;

      .menuItem {
        width: 100px;
        position: absolute;
        top: 54px;
        left: -27px;
        z-index: 100;

        li {
          height: 20px;
          line-height: 20px;
          width: 100%;
          padding: 10px;
          background-color: #f1f2f2 !important;
          margin-bottom: 1px;
        }
      }

      &:hover {
        color: #3b3a3b !important;
      }
    }
  }
}

.container {
  position: fixed;
  z-index: 1;
  width: 100%;
  height: 54px;
  background-color: #181818;
  display: flex;
  justify-content: space-between;
  align-items: center;

  img {
    margin-left: 50px;
  }

  .banner_ul {
    display: flex;
    justify-content: space-between;
    align-items: center;
    // color: #fff;
    font-size: 1.2rem;

    .banner_li {
      flex-shrink: 0;
      line-height: 54px;
      height: 54px;
      position: relative;
      cursor: pointer;
      text-align: center;
      margin-right: 70px;

      .menuItem {
        width: 100px;
        position: absolute;
        top: 54px;
        left: -27px;
        z-index: 100;

        li {
          height: 20px;
          line-height: 20px;
          background-color: #181818;
          width: 100%;
          padding: 10px;
          margin-bottom: 1px;
        }
      }

      &:last-child {
        margin-right: 50px;
      }

      &:hover {
        color: #ececec;
      }
    }
  }
}

@media (max-width: 768px) {
  .back-to-top {
    width: 25%;
  }

  .floating-iframe {
    /* 添加过渡效果 */
    transition: bottom 0.5s ease;
    /* 其他原有样式保持不变 */
    position: fixed;
    right: 0;
    width: 45vw;
    height: 40vh;
    z-index: 1000;
    // background-color: #fff;
  }

  .Main {
    margin: 0;
    padding: 0;

    .allImage {
      width: 100%;
      margin-bottom: 0;
    }

    .setAllBox {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }

  .mt {
    margin-top: 54px;
  }

  .por {
    width: 100%;
    position: relative;
    margin-right: 5px;
  }

  .footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
    height: 90px;

    .footer_left_box_img {
      width: 95px;
      height: 45px;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .first_footer_box {
      p {
        margin: 0;
        font-size: 6px;
        margin-left: 2px;
      }
    }

    .sec_footer_box {
      font-size: 6px;
    }

    .the_footer_box {
      ul {
        display: flex;
        justify-content: space-between;
        align-items: center;

        li {
          width: 50px;
          height: 60px;
          display: flex;
          justify-content: space-around;
          align-items: center;
          background-color: #f5f5f7;
          border-radius: 10px;
          margin-left: 3px;
          flex-direction: column;
          padding-top: 5px;

          img {
            width: 70%;
            padding: 5px;
          }

          p {
            font-size: 6px;
            margin: 0;
            padding-bottom: 10px;
          }
        }
      }
    }
  }

  :deep .btn_el {
    width: 50px;
    border-radius: 40px;
    color: #fff;
    border: none;
    height: 15px;
    background-color: #3971e4;
    font-size: 6px;
    font-weight: normal;
    position: absolute;
    bottom: 5%;
    left: 50%;
    transform: translate(-50%, -50%);

    &:hover {
      color: #fff;
      background-color: #7493f8;
    }
  }

  .container {
    position: fixed;
    z-index: 1;
    width: 100%;
    height: 34px;
    background-color: #181818;
    display: flex;
    justify-content: space-between;
    align-items: center;

    img {
      width: 30px;
      margin-left: 10px;
    }

    .banner_ul {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 2.5rem;

      .banner_li {
        flex-shrink: 0;
        line-height: 54px;
        height: 54px;
        cursor: pointer;
        text-align: center;
        margin-right: 3rem;

        .menuItem {
          width: 50px;
          position: absolute;
          top: 40px;
          left: -17px;
          z-index: 100;

          li {
            height: 10px;
            line-height: 10px;
            background-color: #181818;
            width: 100%;
            padding: 10px;
            margin-bottom: 1px;
          }
        }

        &:last-child {
          margin-right: 20px;
        }

        &:hover {
          color: #ececec;
        }
      }
    }
  }
}

.footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 70px 160px;
  height: 200px;

  .footer_left_box_img {
    width: 300px;
    height: 135px;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .first_footer_box {
    p {
      margin: 0;
      font-size: 20px;
      margin-left: 5px;
    }
  }

  .sec_footer_box {
    font-size: 20px;
  }

  .the_footer_box {
    ul {
      display: flex;
      justify-content: space-between;
      align-items: center;

      li {
        width: 150px;
        height: 180px;
        display: flex;
        justify-content: space-around;
        align-items: center;
        background-color: #f5f5f7;
        border-radius: 10px;
        margin-left: 10px;
        flex-direction: column;
        padding-top: 20px;

        img {
          width: 70%;
          padding: 10px;
        }

        p {
          font-size: 20px;
          margin: 0;
          padding-bottom: 20px;
        }
      }
    }
  }
}

@media (max-width: 768px) {
  .footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
    height: 90px;

    .footer_left_box_img {
      width: 95px;
      height: 45px;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .first_footer_box {
      p {
        margin-top: 0;
        font-size: 6px;
        margin-left: 2px;
      }
    }

    .sec_footer_box {
      font-size: 6px;
    }

    .the_footer_box {
      ul {
        display: flex;
        justify-content: space-between;
        align-items: center;

        li {
          width: 50px;
          height: 60px;
          display: flex;
          justify-content: space-around;
          align-items: center;
          background-color: #f5f5f7;
          border-radius: 10px;
          margin-left: 3px;
          flex-direction: column;
          padding-top: 5px;

          img {
            width: 70%;
            padding: 5px;
          }

          p {
            font-size: 6px;
            margin: 0;
            padding-bottom: 10px;
          }
        }
      }
    }
  }
}
</style>
